import React from 'react'
import SweetAlert from 'react-bootstrap-sweetalert';

export default function(props) {
  let {open, onConfirm, onCancel, component, title, type, buttonText, fullScreen} = props
  return (
      <>
        {open &&
        <SweetAlert
          onConfirm={onConfirm}
          onCancel={onCancel}
          title={title}
          type={type}
          confirmBtnBsStyle={'default'}
          confirmBtnText={buttonText ? buttonText:'Okay'}
          confirmBtnCssClass={'btn effect04'}
          style={fullScreen ? {width: '80vw', zIndex: 100}:{zIndex:100}}
        >
          {component}
        </SweetAlert>
          }
      </>
  )
}
